export default "images/satisfied.png";